import { MARQUEE } from "@/data/site";

const Group = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {MARQUEE.map((t) => (
      <span key={t} className="flex items-center">
        <span className="px-10 font-serif text-4xl font-light text-ivory/80 sm:text-5xl">{t}</span>
        <span className="h-px w-10 bg-line-strong" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="marquee relative overflow-hidden border-y border-line py-8 sm:py-10" data-testid="editorial-marquee" aria-label="Crafted with intention. Built to last.">
    <div className="marquee-track flex w-max">
      <Group />
      <Group hidden />
    </div>
  </section>
);
